module.exports = __webpack_public_path__ + "img/menu-warranty-explain.d81a7deb.svg";